
      var _path, _g, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCartIconBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  viewBox: "0 0 32 32",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "cart-icon-black_1b6413c066390d68__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 6,
  y: 5,
  width: 24,
  height: 13
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.2 5.923H30v11.692H6.2z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#cart-icon-black_1b6413c066390d68__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m9.636 17.615-.09-1.014.009-1.02 16.756-1.456L28.038 8.2a.2.2 0 0 0-.045-.134.23.23 0 0 0-.182-.084L7.18 7.96c-.543 0-.981-.456-.98-1.02 0-.56.44-1.017.981-1.017l20.63.021a2.16 2.16 0 0 1 1.692.82c.41.514.579 1.185.46 1.841a1 1 0 0 1-.026.11l-1.942 6.663a.99.99 0 0 1-.857.72z",
  fill: "#000"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.192 22H11.681c-1.428 0-2.642-1.02-2.952-2.48L5.231 5.142 3.008 5.11C2.451 5.111 2 4.64 2 4.056S2.45 3 3.008 3h2.216c.952 0 1.76.68 1.967 1.653l3.499 14.378c.11.518.515.858.99.858h14.512c.558 0 1.008.472 1.008 1.055 0 .584-.45 1.056-1.008 1.056",
  fill: "#000"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 23.125a2.375 2.375 0 1 1 0 4.75 2.375 2.375 0 0 1 0-4.75Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.25
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 25.5,
  r: 2.375,
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.25
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 32 32\" fill=\"none\"><mask id=\"a\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"6\" y=\"5\" width=\"24\" height=\"13\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.2 5.923H30v11.692H6.2z\" fill=\"#fff\"/></mask><g mask=\"url(#a)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m9.636 17.615-.09-1.014.009-1.02 16.756-1.456L28.038 8.2a.2.2 0 0 0-.045-.134.23.23 0 0 0-.182-.084L7.18 7.96c-.543 0-.981-.456-.98-1.02 0-.56.44-1.017.981-1.017l20.63.021a2.16 2.16 0 0 1 1.692.82c.41.514.579 1.185.46 1.841a1 1 0 0 1-.026.11l-1.942 6.663a.99.99 0 0 1-.857.72z\" fill=\"#000\"/></g><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M26.192 22H11.681c-1.428 0-2.642-1.02-2.952-2.48L5.231 5.142 3.008 5.11C2.451 5.111 2 4.64 2 4.056S2.45 3 3.008 3h2.216c.952 0 1.76.68 1.967 1.653l3.499 14.378c.11.518.515.858.99.858h14.512c.558 0 1.008.472 1.008 1.055 0 .584-.45 1.056-1.008 1.056\" fill=\"#000\"/><path d=\"M13.5 23.125a2.375 2.375 0 1 1 0 4.75 2.375 2.375 0 0 1 0-4.75Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.25\"/><circle cx=\"23.5\" cy=\"25.5\" r=\"2.375\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.25\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/cart-icon-black.1b6413c066390d68d12c06af156f3332.svg"),
        {
          React: SvgCartIconBlack,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      